import { environment } from "src/environments/environment";

export class LogUtil {

	constructor() { }

	/**
	 * imprime un log.
	 * @param msg mensaje a mostrar
	 * @param error false si es mensaje normal. true si es error.
	 */
	public static sendLog(msg: any, error: boolean = false) {
		if (!environment.showLogs) {
			return;
		}

		if (error) {
			console.error(msg);
		} else {
			console.log(msg);
		}
	}

	/**
	 * Imprime un mensaje de error en el log
	 * @param msg
	 */
	public static sendErrorLog(msg: any) {
		this.sendLog(msg, true);
	}
}
